module.exports = __webpack_public_path__ + "media/img/cart-failed-b6c525efa005a0f8c1ddc2f7910acf4d.png";